<cam-tenant-url-displayer [display]="this.display()" [route$]="this.route$" [fetch$]="this.fetch$">
  <ng-content></ng-content>
</cam-tenant-url-displayer>
